// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
* STORYBOOK
* If you add any variable, remember to map it into the proper Story
*/
/**
* Color palette - Facile.it
* https://www.figma.com/design/pyJeLFNc3tpFt5NkWpbt8n/Core-Foundation-%5B1.1%5D?node-id=3-4219&t=DjgtSeE8NgGaxpFm-1
*/
/* Primary */
/* Action */
/* Alert */
/* Success */
/* Help */
/* Error */
/* Chick */
/* Text */
/* Grey */
/* Neutral/warm */
/* Neutral/cold */
/* Opacity/Grey */
/* Opacity/White */
/* Opacity/Colors */
/**
* Color map - Facile.it
*/
/**
* @deprecated use Color - Facile.it palette
*/
/**
* Removes a specific item from a list.
*
* @param {list} \$list List. @param {integer} \$index Index.
* @return {list} Updated list.
*/
/**
* Gets a value from a map.
*
* @param {map} \$map Map.
* @return {string} Value.
*/
.shark .image {
  width: 100%;
  text-align: center;
  line-height: 0;
}
.shark .image.image-circular {
  border-radius: 50%;
  overflow: hidden;
  width: inherit;
  height: inherit;
}
.shark .image.image-border {
  border: 5px solid #f2f2f2;
}
.shark .image.image-margin-auto {
  margin: 0 auto;
}
.shark .image.image-margin-none {
  margin: 0;
}
.shark .image img {
  width: 100%;
}
.shark .image.image-size-std {
  width: 100%;
}
.shark .image.image-size-sm {
  width: 65%;
}
.shark .image.image-size-xs {
  width: 60%;
}
.shark .image.image-size-xxs {
  width: 40%;
}
.shark .image.image-size-mi {
  width: 20%;
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./node_modules/@facile-it/shark-morph/components/Image/image.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;;;CAGC;AACD,YAAY;AACZ,WAAW;AACX,UAAU;AACV,YAAY;AACZ,SAAS;AACT,UAAU;AACV,UAAU;AACV,SAAS;AACT,SAAS;AACT,iBAAiB;AACjB,iBAAiB;AACjB,iBAAiB;AACjB,kBAAkB;AAClB,mBAAmB;AACnB;;CAEC;AACD;;CAEC;AACD;;;;;CAKC;AACD;;;;;CAKC;AACD;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;AAEA,wvFAAwvF","sourcesContent":["/**\n* STORYBOOK\n* If you add any variable, remember to map it into the proper Story\n*/\n/**\n* Color palette - Facile.it\n* https://www.figma.com/design/pyJeLFNc3tpFt5NkWpbt8n/Core-Foundation-%5B1.1%5D?node-id=3-4219&t=DjgtSeE8NgGaxpFm-1\n*/\n/* Primary */\n/* Action */\n/* Alert */\n/* Success */\n/* Help */\n/* Error */\n/* Chick */\n/* Text */\n/* Grey */\n/* Neutral/warm */\n/* Neutral/cold */\n/* Opacity/Grey */\n/* Opacity/White */\n/* Opacity/Colors */\n/**\n* Color map - Facile.it\n*/\n/**\n* @deprecated use Color - Facile.it palette\n*/\n/**\n* Removes a specific item from a list.\n*\n* @param {list} $list List. @param {integer} $index Index.\n* @return {list} Updated list.\n*/\n/**\n* Gets a value from a map.\n*\n* @param {map} $map Map.\n* @return {string} Value.\n*/\n.shark .image {\n  width: 100%;\n  text-align: center;\n  line-height: 0;\n}\n.shark .image.image-circular {\n  border-radius: 50%;\n  overflow: hidden;\n  width: inherit;\n  height: inherit;\n}\n.shark .image.image-border {\n  border: 5px solid #f2f2f2;\n}\n.shark .image.image-margin-auto {\n  margin: 0 auto;\n}\n.shark .image.image-margin-none {\n  margin: 0;\n}\n.shark .image img {\n  width: 100%;\n}\n.shark .image.image-size-std {\n  width: 100%;\n}\n.shark .image.image-size-sm {\n  width: 65%;\n}\n.shark .image.image-size-xs {\n  width: 60%;\n}\n.shark .image.image-size-xxs {\n  width: 40%;\n}\n.shark .image.image-size-mi {\n  width: 20%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
